import React from "react";
import Button from "aldoo-ra/Button"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  currentPage = parseInt(currentPage);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  // Don't render anything if there's no content or only one page
  if (currentPage === 0 || totalPages < 1) return null;

  // Always use the simplified version - only show actual pages
  {
    return (
      <div className="flex items-center justify-center gap-2 mt-10 lg:mt-[100px] xl:mt-[100px]">
        {/* Previous Button */}
        <Button
          variant="nav_icon"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeftIcon className="w-8 h-8 pr-1" />
        </Button>

        {/* Page Numbers - only 1 or 2 */}
        <Button
          onClick={() => handlePageChange(1)}
          variant="nav_icon"
          className={`${
            currentPage === 1
              ? "text-text hover:text-primary"
              : "!text-gray_2 hover:!text-primary"
          }`}
        >
          1
        </Button>
        
        {totalPages === 2 && (
          <Button
            onClick={() => handlePageChange(2)}
            variant="nav_icon"
            className={`${
              currentPage === 2
                ? "text-text hover:text-primary"
                : "!text-gray_2 hover:!text-primary"
            }`}
          >
            2
          </Button>
        )}

        {/* Next Button */}
        <Button
          variant="nav_icon"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRightIcon className="w-8 h-8 pl-1" />
        </Button>
      </div>
    );
  }

  // Generate array of actual page numbers from 1 to totalPages
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-10 lg:mt-[100px] xl:mt-[100px]">
      {/* Previous Button */}
      <Button
        variant="nav_icon"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeftIcon className="w-8 h-8 pr-1" />
      </Button>

      {/* Page Numbers - only show actual pages */}
      {pageNumbers.map((page) => (
        <Button
          key={page}
          onClick={() => handlePageChange(page)}
          variant="nav_icon"
          className={`${
            currentPage === page
              ? "text-text hover:text-primary"
              : "!text-gray_2 hover:!text-primary"
          }`}
        >
          {page}
        </Button>
      ))}

      {/* Next Button */}
      <Button
        variant="nav_icon"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRightIcon className="w-8 h-8 pl-1" />
      </Button>
    </div>
  );
};

export default Pagination;